import { render, staticRenderFns } from "./acDetail.vue?vue&type=template&id=6dc54596"
import script from "./acDetail.vue?vue&type=script&lang=js"
export * from "./acDetail.vue?vue&type=script&lang=js"
import style0 from "./acDetail.vue?vue&type=style&index=0&id=6dc54596&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports